<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconConnectionIndicatorMedium_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <g fill="#fff" clip-path="url(#IconConnectionIndicatorMedium_24__a)">
        <rect width="4" height="4" x="4" y="16" rx="1" />
        <rect width="4" height="9" x="10" y="11" rx="1" />
        <rect width="4" height="16" x="16" y="4" opacity=".3" rx="1" />
    </g>
    <defs>
        <clipPath id="IconConnectionIndicatorMedium_24__a">
            <path fill="currentColor" d="M0 0h24v24H0z" />
        </clipPath>
    </defs>
</svg>
